module.exports = __webpack_public_path__ + "static/media/0822.dfc724fe.jpg";